import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import imageUpload from "../../../services/upload";
import {
  Card,
  CardContent,
  CardActions,
  Box,
  Breadcrumbs,
  FormControl,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
  Button,
  Typography,
  CardMedia,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import RichTextEditor from "react-rte";
import { IMAGE_PATH, instanceToken } from "../../../utils/constant";
import axios from "axios";
import emergencieService from "../../../services/emergencieService";
import { zodResolver } from "@hookform/resolvers/zod";
import { CreateNewEmergencySchema } from "../../../schema/CreateNewEmergencySchema";
import { useForm } from "react-hook-form";

const imgFileTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"];

export default function UpdateEmergencies({ homeAlert }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageFileUrl, setImageFileUrl] = useState("");
  const [values, setValues] = useState({ image_url: "" });
  const [nameEng, setNameEng] = useState("");
  const [nameMM, setNameMM] = useState("");
  const [addressEng, setAddressEng] = useState("");
  const [addressMM, setAddressMM] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneNote, setPhoneNote] = useState("");
  const [category, setCategory] = useState("");
  const [link, setLink] = useState("");
  const [image, setImage] = useState("");
  const [oldImageName, setOldImageName] = useState();
  const [errorMessage, setErrorMessage] = useState({});

  const [emergencies, setEmergencies] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(CreateNewEmergencySchema),
    initialValues: {
      name_en: "",
      name_mm: "",
      address_en: "",
      address_mm: "",
      phone: "",
      phone_note: "",
      category: "",
      link: "",
    },
  });

  async function getImageUrl(imgData) {
    const response = await imageUpload.getImageUrl(
      instanceToken.token,
      imgData
    );
    const result = response.data;
    const path = IMAGE_PATH + result?.imageName;
    setImageFileUrl(result?.imageUploadUrl);
    setValues({
      ...values,
      image_url: path,
    });
  }
  useEffect(() => {
    if (!emergencies) {
      fetchEmergencies();
    }
  }, []);

  useEffect(() => {
    setNameEng(emergencies?.name_en);
    setNameMM(emergencies?.name_mm);
    setAddressEng(emergencies?.address_en);
    setAddressMM(emergencies?.address_mm);
    setLink(emergencies?.link);
    setPhone(emergencies?.phone);
    setPhoneNote(emergencies?.phone_note);
    setCategory(emergencies?.category);

    if (emergencies) {
      setValue("name_en", emergencies?.name_en);
      setValue("name_mm", emergencies?.name_mm);
      setValue("link", emergencies?.link);
      setValue("address_en", emergencies?.address_en);
      setValue("address_mm", emergencies?.address_mm);
      setValue("phone", emergencies?.phone);
      setValue("phone_note", emergencies?.phone_note);
      setValue("category", emergencies?.category);

      setValues({
        image_url: emergencies?.image_url || "",
      });
    }
  }, [emergencies, setValue]);

  const fetchEmergencies = async () => {
    try {
      const res = await emergencieService.getOneEmergencies(
        instanceToken.token,
        id
      );
      setEmergencies(res.data);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };
  const changeNameEng = (e) => {
    setNameEng(e.target.value);
  };
  const changeNameMM = (e) => {
    setNameMM(e.target.value);
  };
  const changeAddressEng = (e) => {
    setAddressEng(e.target.value);
  };
  const changeAddressMM = (e) => {
    setAddressMM(e.target.value);
  };
  const changePhone = (e) => {
    setPhone(e.target.value);
  };
  const changePhoneNote = (e) => {
    setPhoneNote(e.target.value);
  };
  const changeLink = (e) => {
    setLink(e.target.value);
  };

  const changeCategory = (e) => {
    setCategory(e.target.value);
  };

  const changeFile = async (e) => {
    if (e.target.files && e.target.files[0]) {
      if (e.target.files && e.target.files[0]) {
        const img = e.target.files[0];
        if (!imgFileTypes.includes(img.type)) {
          setErrorMessage({
            ...errorMessage,
            image_url: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
          });
          return;
        }
        if (img.size > 204800) {
          setErrorMessage({
            ...errorMessage,
            image_url: "Image file size must be smaller than 200KB.",
          });
          return;
        }
        setImageFile(img);
        setImagePreview(URL.createObjectURL(img));
        getImageUrl(img);
      }
    }
  };
  const formData = new FormData();

  const handleUpdate = async (data) => {
    formData.append("name_en", data?.name_en);
    formData.append("name_mm", data?.name_mm);
    formData.append("address_en", data?.address_en);
    formData.append("address_mm", data?.address_mm);
    formData.append("phone", data?.phone);
    formData.append("phone_note", data?.phone_note);
    formData.append("link", data?.link);
    formData.append("category", data?.category);
    formData.append("image_data", "");
    formData.append(
      "image_url",
      values?.image_url ? values?.image_url : data?.image_url
    );

    try {
      setLoading(true);
      if (imageFile) {
        await imageUpload.uploadImage(imageFileUrl, imageFile);
      }
      const response = await emergencieService.putEmergencies(
        instanceToken.token,
        id,
        formData
      );
      navigate("/emergencies");
      setEmergencies(response.data);
      homeAlert("Emergencies have been updated.", false);
    } catch (error) {
      console.log(error);
      homeAlert("Error on server.", true);
    } finally {
      setLoading(false);
      setErrorMessage({});
    }
  };
  return (
    <form onSubmit={handleSubmit(handleUpdate)}>
      <div role="presentation" style={{ marginBlockEnd: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/emergencies">Emergencies</Link>
          <span>Update Emergencies</span>
        </Breadcrumbs>
      </div>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Card sx={{ minWidth: "80vw" }}>
          <CardContent sx={{ display: "flex", pb: 0, flexDirection: "column" }}>
            <Box
              sx={{
                maxWidth: "40vw",
                display: "grid",
                justifyContent: "center",
                // bgcolor: "red",
                ml: 31,
                borderRadius: 2,
                boxShadow: 2,
              }}
            >
              <CardMedia
                component="img"
                height="320"
                image={imagePreview ? imagePreview : values?.image_url}
                sx={{ my: 2 }}
              />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {/* image */}
              <FormControl sx={{ my: 2, maxWidth: 400 }}>
                <Typography
                  sx={{
                    mb: 1,
                    fontSize: "12px",
                    display: "flex",
                    textAlign: "center",
                  }}
                >
                  Rendered size must be 340 * 180 px , Aspect ratio must be
                  1.8:1 and resolution must be 72ppi
                </Typography>
                <Button
                  variant="contained"
                  component="label"
                  size="large"
                  sx={{ p: 2 }}
                >
                  <PhotoCamera />
                  <Typography sx={{ ml: 1 }}>Upload Image</Typography>
                  <input
                    hidden
                    onChange={changeFile}
                    accept="image/png, image/jpeg, image/jpg, image/gif, image/svg+xml"
                    type="file"
                    error={errorMessage["image_url"]}
                    FormHelperText={errorMessage["image_url"]}
                  />
                </Button>
                <FormHelperText error>
                  {errorMessage["image_url"]}
                </FormHelperText>
              </FormControl>
            </Box>
            {/* name */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              {/* name Eng */}
              <FormControl sx={{ my: 2, maxWidth: 800 }} variant="outlined">
                <TextField
                  id="name_en"
                  label="Name Eng"
                  {...register("name_en")}
                  onChange={changeNameEng}
                  value={nameEng}
                  error={!!errors.name_en}
                  helperText={errors.name_en?.message}
                />
              </FormControl>
              {/* Nmae MM */}
              <FormControl sx={{ my: 2 }} variant="outlined">
                <TextField
                  id="name_mm"
                  label="Name MM"
                  {...register("name_mm")}
                  onChange={changeNameMM}
                  value={nameMM}
                  error={!!errors.name_mm}
                  helperText={errors.name_mm?.message}
                />
              </FormControl>
            </Box>
            {/* address */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              {/* address Eng */}
              <FormControl sx={{ my: 2, maxWidth: 800 }} variant="outlined">
                <TextField
                  id="address_en"
                  label="Address Eng"
                  {...register("address_en")}
                  onChange={changeAddressEng}
                  value={addressEng}
                  error={!!errors.address_en}
                  helperText={errors.address_en?.message}
                />
              </FormControl>
              {/* Address MM */}
              <FormControl sx={{ my: 2 }} variant="outlined">
                <TextField
                  id="address_mm"
                  label="Address MM"
                  {...register("address_mm")}
                  onChange={changeAddressMM}
                  value={addressMM}
                  error={!!errors.address_mm}
                  helperText={errors.address_mm?.message}
                />
              </FormControl>
            </Box>
            {/* address */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              {/* phone*/}
              <FormControl sx={{ my: 2, maxWidth: 800 }} variant="outlined">
                <TextField
                  id="phone"
                  label="Phone"
                  {...register("phone")}
                  onChange={changePhone}
                  value={phone}
                  error={!!errors.phone}
                  helperText={errors.phone?.message}
                />
              </FormControl>
              {/* phoneNote */}
              <FormControl sx={{ my: 2 }} variant="outlined">
                <TextField
                  id="phone_note"
                  label="Phone Note"
                  {...register("phone_note")}
                  onChange={changePhoneNote}
                  value={phoneNote}
                  error={!!errors.phone_note}
                  helperText={errors.phone_note?.message}
                />
              </FormControl>

              {/* category */}
              {/* Category */}
              <FormControl sx={{ my: 2 }}>
                <InputLabel id="category">Category</InputLabel>
                <Select
                  labelId="category"
                  label="category"
                  defaultValue=""
                  {...register("category")}
                  onChange={changeCategory}
                  value={category}
                  error={!!errors.category}
                  helperText={errors.category?.message}
                  //error={errorMessage.category ? true : false}
                >
                  <MenuItem value="" disabled>
                    Value
                  </MenuItem>
                  <MenuItem value="Emergency Hotline">
                    Emergency Hotline
                  </MenuItem>
                  <MenuItem value="Ambulance">Ambulance</MenuItem>
                  <MenuItem value="Oxygen">Oxygen</MenuItem>
                  <MenuItem value="Blood Donation">Blood Donation</MenuItem>
                </Select>
                {/* {errorMessage.category && (
                  <FormHelperText error>{errorMessage.category}</FormHelperText>
                )} */}
                <FormHelperText error>
                  {errorMessage["category"]}
                </FormHelperText>
              </FormControl>

              {/* link */}
              <FormControl sx={{ my: 2 }} variant="outlined">
                <TextField
                  id="link"
                  label="Link"
                  {...register("link")}
                  onChange={changeLink}
                  value={link}
                  error={!!errors.link}
                  helperText={errors.link?.message}
                />
              </FormControl>
            </Box>
          </CardContent>

          <CardActions sx={{ justifyContent: "end" }}>
            <LoadingButton
              type="submit"
              variant="contained"
              loading={loading}
              // onClick={handleUpdate}
              sx={{ backgroundColor: "#4b26d1", alignSelf: "end" }}
            >
              Update
            </LoadingButton>
          </CardActions>
        </Card>
      </Box>
    </form>
  );
}
